import { Badge, BadgeColor } from '@pandiafi/design-system'
import classNames from 'classnames'
import React from 'react'
import { useTranslation } from 'react-i18next'

export const ComingSoonLink: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { t } = useTranslation(['common'])
  return (
    <div className="flex space-x-2 items-center justify-start text-common-gray-7 pointer-events-none font-light z-0">
      <span className="mr-1">{children}</span>

      <Badge className={classNames('uppercase')} color={BadgeColor.GRAY}>
        {t('comingSoon')}
      </Badge>
    </div>
  )
}
